import { getPercent } from '@cutwise/utils';

import { HistogramScale } from '@carbon/dm-industrial/lib/dm-industrial';

import { HistogramMeasurement } from './Histogram.types';

export function getHistogramMeasurements(
  histogram: number[],
  histogramScaleView: HistogramScale,
  element: Nullable<HTMLDivElement>,
): Nullable<HistogramMeasurement> {
  if (!element) {
    return null;
  }

  let histogramData = [...histogram];

  let highestAbsoluteValue = 0;
  let total = 0;

  for (let i = 0; i < histogram.length; i++) {
    if (histogram[i] > highestAbsoluteValue) {
      highestAbsoluteValue = histogram[i];
    }

    total += histogram[i];
  }

  if (histogramScaleView === HistogramScale.Log) {
    histogramData = histogramData.map((value) => (value > 0 ? Math.log10(value) : 0));
  }

  const { width } = element.getBoundingClientRect();
  const barWidth = width / histogramData.length;

  const highest = histogramScaleView === HistogramScale.Log ? Math.log10(highestAbsoluteValue) : highestAbsoluteValue;
  const maxPercent = (highestAbsoluteValue / total) * 100;

  let yAxis: number[] = [];

  if (maxPercent) {
    if (histogramScaleView === HistogramScale.Linear) {
      yAxis = [maxPercent, maxPercent * (2 / 3), maxPercent * (1 / 3)];
    }

    if (histogramScaleView === HistogramScale.Log) {
      yAxis = [maxPercent, Math.log10(maxPercent * (2 / 3)), Math.log10(maxPercent * (1 / 3))];
    }
  }

  return {
    total,
    maxPercent,
    container: {
      width,
    },
    yAxis,
    data: [...histogramData].map((data, i) => {
      const height = getPercent(data, highest);

      return {
        absoluteValue: data,
        width: getPercent(barWidth, width),
        height,
        top: 100 - height,
        left: getPercent(i * barWidth, width),
      };
    }),
  };
}
